// services/contactService.js
import { apiService } from './api';

const contactService = {
  // Récupérer tous les messages de contact
  getContacts: async () => {
    try {
      const response = await apiService.get('/contact');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des contacts:', error);
      throw error;
    }
  },
  
  // Marquer un message comme lu (optionnel)
  markAsRead: async (contactId) => {  // NON UTILISé
    try {
      const response = await apiService.put(`/contacts/${contactId}/read`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors du marquage comme lu:', error);
      throw error;
    }
  },
  
  // Supprimer un message (optionnel)
  deleteContact: async (contactId) => {  // NON UTILISé
    try {
      const response = await apiService.delete(`/contacts/${contactId}`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression:', error);
      throw error;
    }
  }
};

export { contactService };